/** Rental cost calculator (templates/page.rental-calculator.liquid). */

(function () {
  const form = document.querySelector('[data-rental-calc]');
  const dataEl = document.getElementById('rental-calc-data');
  if (!form || !dataEl) return;

  const data = JSON.parse(dataEl.textContent);
  const $ = (sel) => document.querySelector(sel);
  const modelSelect = $('[data-calc-model]');
  const countInput = $('[data-calc-count]');
  const countLabel = $('[data-calc-count-label]');
  const deliveryBox = $('[data-calc-delivery]');
  const deliveryOnlyNote = $('[data-calc-delivery-only]');
  const deliveryChoice = deliveryBox.closest('label');
  const zipWrap = $('[data-calc-zip-wrap]');
  const zipInput = $('[data-calc-zip]');
  const zipResult = $('[data-calc-zip-result]');
  const out = {
    total: $('[data-calc-total]'),
    rental: $('[data-calc-line-rental]'),
    delivery: $('[data-calc-line-delivery]'),
    pickup: $('[data-calc-line-pickup]'),
    hint: $('[data-calc-hint]'),
  };
  const text = {
    select: out.hint.textContent,
    zipNeeded: out.hint.dataset.zipNeeded,
    callQuote: out.hint.dataset.callQuote,
    unknownZip: out.hint.dataset.unknownZip,
    ready: out.hint.dataset.ready,
    zipFee: out.hint.dataset.zipFee,
  };

  let zipTable = null;
  let zipTablePromise = null;
  function loadZipTable() {
    if (!zipTablePromise) {
      zipTablePromise = fetch(data.zipTable)
        .then((response) => response.json())
        .then((table) => {
          zipTable = table;
          return table;
        })
        .catch(() => {
          zipTable = {};
          return zipTable;
        });
    }
    return zipTablePromise;
  }

  let refreshed = false;
  function refreshOnce() {
    if (refreshed) return;
    refreshed = true;
    update();
  }

  const money = (n) => '$' + Math.round(n).toLocaleString('en-US');

  // Fill the equipment list: items with one model are a plain option, items with several get a group.
  const models = [];
  data.items.forEach((item) => {
    const parent = item.models.length > 1 ? document.createElement('optgroup') : modelSelect;
    if (item.models.length > 1) {
      parent.label = item.name;
      modelSelect.appendChild(parent);
    }
    item.models.forEach((model) => {
      const option = document.createElement('option');
      option.value = String(models.length);
      option.textContent = item.models.length > 1 ? model.name : item.name;
      option.dataset.key = item.key;
      parent.appendChild(option);
      models.push({ item, model });
    });
  });

  // Preselect from ?item={calculator_key}
  const wanted = new URLSearchParams(window.location.search).get('item');
  if (wanted) {
    // Prefer the Standard model when an item has several, otherwise its first model
    const standard = models.findIndex((entry) => entry.item.key === wanted && /standard/i.test(entry.model.name));
    const match = standard > -1 ? standard : models.findIndex((entry) => entry.item.key === wanted);
    if (match > -1) modelSelect.value = String(match);
  }

  function tierForZip(zip) {
    if (!/^\d{5}$/.test(zip)) return { state: 'incomplete' };
    if (!zipTable) return { state: 'loading' };
    if (!(zip in zipTable)) return { state: 'unknown' };
    const tier = zipTable[zip];
    if (tier > data.maxTier) return { state: 'quote' };
    return { state: 'ok', tier };
  }

  function update() {
    const period = form.querySelector('[data-calc-period]:checked').value;
    countLabel.textContent = countLabel.dataset[period];
    const count = Math.max(1, parseInt(countInput.value, 10) || 1);

    const chosen = models[parseInt(modelSelect.value, 10)];
    const deliveryOnly = Boolean(chosen && chosen.item.deliveryOnly);
    deliveryOnlyNote.hidden = !deliveryOnly;
    // Delivery-only items always need delivery, so the checkbox is hidden and the note explains why.
    // Other items keep whatever the customer chose.
    deliveryChoice.hidden = deliveryOnly;
    const needsDelivery = deliveryOnly || deliveryBox.checked;
    zipWrap.hidden = !needsDelivery;
    if (needsDelivery) loadZipTable().then(refreshOnce);

    if (!chosen) {
      out.total.textContent = '$0';
      out.rental.textContent = '$0';
      out.delivery.textContent = '$0';
      out.pickup.textContent = '$0';
      out.hint.textContent = text.select;
      return;
    }

    const rental = (period === 'week' ? chosen.model.week : chosen.model.month) * count;
    let fee = 0;
    let hint = text.ready;
    zipResult.textContent = '';

    if (needsDelivery) {
      const result = tierForZip(zipInput.value.trim());
      if (result.state === 'ok') {
        fee = data.baseFee + data.tierStep * result.tier;
        zipResult.textContent = text.zipFee.replace('[fee]', money(fee));
      } else if (result.state === 'quote') {
        hint = text.callQuote;
        zipResult.textContent = text.callQuote;
      } else if (result.state === 'unknown') {
        hint = text.unknownZip;
        zipResult.textContent = text.unknownZip;
      } else {
        hint = text.zipNeeded;
      }
    }

    out.rental.textContent = money(rental);
    out.delivery.textContent = money(fee);
    out.pickup.textContent = money(fee);
    out.total.textContent = money(rental + fee * 2);
    out.hint.textContent = hint;
  }

  form.addEventListener('input', update);
  form.addEventListener('change', update);
  zipInput.addEventListener('focus', loadZipTable, { once: true });
  zipInput.addEventListener('input', () => {
    zipInput.value = zipInput.value.replace(/\D/g, '').slice(0, 5);
    loadZipTable().then(update);
  });
  form.addEventListener('submit', (event) => event.preventDefault());

  update();
})();
